"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Item = function (props) {
    var _a = props.length, length = _a === void 0 ? 4 : _a, _b = props.themeType, themeType = _b === void 0 ? 'pure' : _b, _c = props.link, link = _c === void 0 ? '' : _c;
    return (react_1.default.createElement("div", { className: "list ".concat(themeType, "-color col-").concat(length) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('item', link ? 'link-item' : '') },
            link && react_1.default.createElement("a", { className: "link", href: link }),
            react_1.default.createElement(Render, __assign({}, props)),
            react_1.default.createElement("div", { className: "bg" }))));
};
var Render = function (props) {
    var title = props.title, content = props.content, num = props.num, length = props.length, _a = props.themeType, themeType = _a === void 0 ? 'pure' : _a, _b = props.fontColor, fontColor = _b === void 0 ? '' : _b;
    if (length === 1) {
        // 数据为1个 布局不同，单独render
        if (themeType === 'pure')
            return null; // 纯色类型最少需要两个数据
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'num' },
                react_1.default.createElement("span", { className: (0, classnames_1.default)(fontColor ? 'font-num-span' : 'num-span') }, num)),
            react_1.default.createElement("div", { className: "right" },
                title && react_1.default.createElement("div", { className: "title" }, title),
                content && react_1.default.createElement("div", { className: "content" }, content))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement("div", { className: "title" }, title),
        num && (react_1.default.createElement("div", { className: 'num' },
            react_1.default.createElement("span", { className: (0, classnames_1.default)(fontColor ? 'font-num-span' : 'num-span'), style: {
                    color: fontColor,
                } }, num))),
        content && react_1.default.createElement("div", { className: "content" }, content)));
};
exports.default = Item;
//# sourceMappingURL=Item.js.map